import { sendOperationalAnalyticsEvent } from '../../common/analytics/analytics-web-client';
import { isSpaceConnected } from '../confluence/connected-space/selectors';
import { areSpacesLoaded, getAvailableSpaces } from '../confluence/spaces/selectors';
import { type State } from '../types';
import { type SiteTraits } from './types';
export const AUTO_PROVISION_DATE_TRAIT = 'confluence.auto-provision.activationDate';

export const getSiteTraits = (state: State): SiteTraits[] => state.personalization.siteTraits;

export const isConfluenceAutoProvisioned = (state: State): boolean => {
	try {
		const siteTraits = getSiteTraits(state);
		if (siteTraits.length < 1) {
			return false;
		}
		const autoProvisionDateTrait = siteTraits.find(
			(trait) => trait.name === AUTO_PROVISION_DATE_TRAIT,
		);
		if (!autoProvisionDateTrait || !autoProvisionDateTrait.value) {
			return false;
		}
		return !!autoProvisionDateTrait.value;
	} catch (error: any) {
		sendOperationalAnalyticsEvent({
			source: 'projectPages',
			action: 'failed',
			actionSubject: 'autoProvisionedConfluenceEligibilityCheck',
			attributes: {
				errorMessage: error
					? error.message
					: 'Unknown error when determining the eligibilty of auto-provisioned Confluence site trait in isConfluenceAutoProvisioned selector',
			},
		});
		return false;
	}
};

export const shouldCreateSpaceForAutoProvisionedConfluence = (state: State): boolean => {
	const hasConnectedSpace = isSpaceConnected(state);
	const hasAvailableSpaces = getAvailableSpaces(state).length > 0;
	const hasAutoProvisionedConfluenceTrait = isConfluenceAutoProvisioned(state);
	const areAvailableSpacesLoaded = areSpacesLoaded(state);
	return (
		hasAutoProvisionedConfluenceTrait &&
		areAvailableSpacesLoaded &&
		!hasConnectedSpace &&
		!hasAvailableSpaces
	);
};
